import { put, takeEvery } from "redux-saga/effects";
import requestWithSubTenantIfNeeded from "../requestWithSubTenantIfNeeded";
import * as actions from "@p81-common/shell-core-js/dist/redux/groupsGet";

function* groupsGet(action) {
  try {
    const { searchParams = {} } = action || {};
    const response = yield requestWithSubTenantIfNeeded("get", "groups", {
      searchParams,
    });
    yield put(actions.requestSuccess(response.data.data));
  } catch (e) {
    yield put(actions.requestFailure(e));
  }
}

function* saga() {
  yield takeEvery(actions.GROUPS_GET_REQUEST, groupsGet);
}

export default saga;
